/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';

export function reviews() {

  // $('.commentlist').hide();
  // $('.readReviews').on('click tap', function() {
  //   $(this).addClass('hiding');
  //   $('.commentlist').slideDown();
  // });

  // $('.woocommerce-product-rating').on('click tap', function() {
  //   $('.readReviews').trigger('click');
  // });

  $('.comment-respond').hide();
  $('.submitReview__button').on('click tap', function() {
    $(this).addClass('hiding');
    $('.reviews').addClass('formOpen');
    $('.comment-respond').slideDown().addClass('open');
    $('.submitReview__close').addClass('showing');
  });

  $('.submitReview__close').on('click tap', function() {
    $('.submitReview__close').removeClass('showing');
    $('.submitReview__button').removeClass('hiding');
    $('.reviews').removeClass('formOpen');
    $('.comment-respond').slideUp().removeClass('open');
  });
}

